import { render, staticRenderFns } from "./WarningDepot.vue?vue&type=template&id=521b8ffe&"
import script from "./WarningDepot.vue?vue&type=script&lang=js&"
export * from "./WarningDepot.vue?vue&type=script&lang=js&"
import style0 from "./WarningDepot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports